import { useCallback } from "react";

/** Shared guardians array patch applied via parent's `updateData`. */
export function useBondPrincipalGuardianPatch(data, updateData, keys) {
  const updateGuardianAt = useCallback(
    (index, patch, guardians) => {
      const updated = [...guardians];
      updated[index] = { ...updated[index], ...patch };
      updateData({ ...data, guardians: updated });
    },
    [data, updateData]
  );

  const patchPrincipalField = useCallback(
    (index, logical, value, guardians, extra = {}) => {
      const updatedGuardians = [...guardians];
      updatedGuardians[index] = {
        ...updatedGuardians[index],
        [keys[logical]]: value,
        ...extra,
      };
      updateData({ ...data, guardians: updatedGuardians });
    },
    [data, keys, updateData]
  );

  return { updateGuardianAt, patchPrincipalField };
}
